import * as tslib_1 from "tslib";
import * as React from 'react';
import PropTypes from 'prop-types';
import Scrollbar from '../Scrollbar';

var InfiniteScroll =
/** @class */
function (_super) {
  tslib_1.__extends(InfiniteScroll, _super);

  function InfiniteScroll() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.scrollbar = null;
    _this.enabledListener = false;

    _this.scrollListener = function () {
      if (!_this.enabledListener || !_this.scrollbar) {
        return;
      }

      var _a = _this.props,
          threshold = _a.threshold,
          loadMore = _a.loadMore;

      var offset = _this.scrollbar.getOffset();

      if (offset === undefined) {
        return;
      }

      if (offset < threshold) {
        _this.disableListener();

        _this.pageLoaded += 1;
        loadMore(_this.pageLoaded);
      }
    };

    _this.ref = function (node) {
      var innerRef = _this.props.innerRef;
      _this.scrollbar = node;

      if (innerRef) {
        innerRef(node);
      }
    };

    return _this;
  }

  InfiniteScroll.prototype.componentDidMount = function () {
    var _a = this.props,
        pageStart = _a.pageStart,
        hasMore = _a.hasMore;
    this.pageLoaded = pageStart;
    hasMore && this.enableListener();
    this.scrollListener();
  };

  InfiniteScroll.prototype.componentWillReceiveProps = function (nextProps) {
    if (!nextProps.hasMore && this.props.hasMore) {
      this.disableListener(); // its needed for using multi-list with infiniteScroll,
      // wich doesnt re-render and just passes new props
    }
  };

  InfiniteScroll.prototype.componentDidUpdate = function () {
    var hasMore = this.props.hasMore;
    hasMore && this.enableListener();
    this.scrollListener();
  };

  InfiniteScroll.prototype.enableListener = function () {
    this.enabledListener = true;
  };

  InfiniteScroll.prototype.disableListener = function () {
    this.enabledListener = false;
  };

  InfiniteScroll.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        element = _a.element,
        hasMore = _a.hasMore,
        spinner = _a.spinner;
    var children = this.props.children;

    if (hasMore) {
      children = React.Children.toArray([children, spinner]);
    }

    return React.createElement(Scrollbar, {
      className: className,
      style: style,
      ref: this.ref,
      onScrollDown: this.scrollListener
    }, React.createElement(element, null, children));
  };

  InfiniteScroll.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.node,
    innerRef: PropTypes.func,

    /** Name of the element that the component should render as. */
    element: PropTypes.string,

    /** Event listeners are removed if false. */
    hasMore: PropTypes.bool,

    /** Spinner which will be render when occurs load new items */
    spinner: PropTypes.node,

    /** The number of the first page to load.
     * With the default of 0, the first page is 1
     */
    pageStart: PropTypes.number,

    /** The distance in pixels before the end of the items
     * that will trigger a call to loadMore
     */
    threshold: PropTypes.number,

    /** Callback when more items are requested by the user. */
    loadMore: PropTypes.func.isRequired
  };
  InfiniteScroll.defaultProps = {
    children: [],
    element: 'div',
    hasMore: false,
    pageStart: -1,
    spinner: React.createElement("div", null),
    threshold: 250
  };
  return InfiniteScroll;
}(React.Component);

export default InfiniteScroll;

try {
  // @ts-ignore
  InfiniteScroll.__docgenInfo = {
    "description": "",
    "displayName": "InfiniteScroll",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "style": {
        "defaultValue": null,
        "description": "",
        "name": "style",
        "required": false,
        "type": {
          "name": "CSSProperties | undefined"
        }
      },
      "hasMore": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "hasMore",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "pageStart": {
        "defaultValue": {
          value: "-1"
        },
        "description": "",
        "name": "pageStart",
        "required": true,
        "type": {
          "name": "number"
        }
      },
      "loadMore": {
        "defaultValue": null,
        "description": "",
        "name": "loadMore",
        "required": true,
        "type": {
          "name": "(page: number) => void"
        }
      },
      "spinner": {
        "defaultValue": null,
        "description": "",
        "name": "spinner",
        "required": true,
        "type": {
          "name": "ReactNode"
        }
      },
      "element": {
        "defaultValue": {
          value: "div"
        },
        "description": "",
        "name": "element",
        "required": true,
        "type": {
          "name": "ReactType<any>"
        }
      },
      "innerRef": {
        "defaultValue": null,
        "description": "",
        "name": "innerRef",
        "required": false,
        "type": {
          "name": "((el: Scrollbar) => void) | undefined"
        }
      },
      "threshold": {
        "defaultValue": {
          value: "250"
        },
        "description": "",
        "name": "threshold",
        "required": true,
        "type": {
          "name": "number"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}